module.exports = __webpack_public_path__ + "static/handout-2057e1eade4c8e77dd78b626cf493dac.png";